import { Stack } from 'expo-router';
import { CustomTextStyles } from '@/components/CustomText';
import { AppText } from '@/components/AppText';
import DrawerButton from '@/components/DrawerButton';
import { HeaderLeft } from '@/components/HeaderLeft';

export default function StackedMainLoggedIn() {
  return (
    <Stack
      screenOptions={{
        headerTitleStyle: CustomTextStyles.headerTitle,

        // Remove horizontal bottom line for header
        headerShadowVisible: false,

        headerStyle: {
          backgroundColor: 'transparent',
        },

        headerTitle: (props) => <AppText {...props} style={CustomTextStyles.headerTitle} />,

        headerLeft: () => <HeaderLeft />,

        headerRight: () => <DrawerButton />,
      }}
    >
      <Stack.Screen name="rabblname" options={{ title: 'Rabbl Name' }} />
      <Stack.Screen name="covercharge" options={{ title: 'Rabbl Cover Charge' }} />
      <Stack.Screen name="rabblvisuals" options={{ title: 'Rabbl Visuals' }} />
      <Stack.Screen name="rabbldetails" options={{ title: 'Rabbl Details' }} />
      <Stack.Screen name="rabblbackground" options={{ title: 'Background' }} />
      <Stack.Screen name="waitingapproval" options={{ title: 'Waiting Approval' }} />
      <Stack.Screen name="rabbllink" options={{ title: 'Rabbl Link' }} />
      <Stack.Screen name="user_info" options={{ title: 'Terms' }} />
      <Stack.Screen name="manage" options={{ title: 'Manage', headerShown: false }} />
    </Stack>
  );
}
